export const LINK_BANK_TILES = 'LINK_BANK_TILES';
export const linkBankTiles = () => ({
	type: LINK_BANK_TILES,
});

export const LINK_BANK_MICROS_SUBMIT = 'LINK_BANK_MICROS_SUBMIT';
export const linkBankMicrosSubmit = () => ({
	type: LINK_BANK_MICROS_SUBMIT,
});

export const LINK_BANK_SKIP = 'LINK_BANK_SKIP';
export const linkBankSkip = () => ({
	type: LINK_BANK_SKIP,
});

export const SET_BANK_LINK_REDIRECT_URI = 'SET_BANK_LINK_REDIRECT_URI';
export const setBankLinkRedirectUri = (oauthRedirectUri) => ({
	type: SET_BANK_LINK_REDIRECT_URI,
	oauthRedirectUri,
});

export const SET_IS_BANK_LINK_DRAWER_MODAL_OPEN = 'SET_IS_BANK_LINK_DRAWER_MODAL_OPEN';
export const setIsBankLinkDrawerModalOpen = (isOpen) => ({
	type: SET_IS_BANK_LINK_DRAWER_MODAL_OPEN,
	isOpen,
});
